import { useState,useEffect, useContext } from "react";
import { Form, message } from "antd";
import { useHistory } from "react-router-dom";
import useHttpClient from 'shared/hooks/http-hook';
import { AuthContext } from 'shared/context/auth-context';
import  EndPoints from 'shared/endPoints/EndPoints.json'
import { usePackage } from "./package-context";
import PackingForm from "./PackingForm";

export default function CreatePackage() {
    const { sendRequest, responseData, requestIdentifier, responseMessage, status } = useHttpClient();
    const { carrierCompany, deviceType,  deviceTypeId } = usePackage()
    const { UserId } = useContext(AuthContext);
    const history = useHistory()
    const [form] = Form.useForm();
    const [isNewOnChangeValue, setIsNewOnChangeValue] = useState(false)
    
    const handleIsNewChanged = () => {
        setIsNewOnChangeValue(!isNewOnChangeValue)
    }
    useEffect(() => {
        if (status === 'resolved' && requestIdentifier === 'POSTPARCEL') {
            message.success(responseMessage, 2.5)
                .then(() => history.push('/choices/new-device'))
        }
    }, [requestIdentifier, history, responseMessage, status])

    useEffect(() => {
        if (status === 'rejected') {
            let result;
            Object.keys(responseData).forEach((key) => {
                result = responseData[key]
            })
            message.error(result)
        }
    }, [status, responseData])

    const onFinish = (values) => {
        const data = {
            capacity: values.capacity,
            isNew: !values.isNew,
            applicationUserId: UserId,
            deviceTypeId: values.deviceType,
            carrierCompanyId: values.carrierCompany,
            useNewSIM: values.useNewSIM
        }

        sendRequest({
            endpoint: EndPoints.PARCEL.POSTPARCEL,
            method: 'POST',
            data
        }, 'POSTPARCEL', 'Η Δημιουργία του πακέτου ήταν επιτυχής')
    }
    return (
        <PackingForm
            form={form}
            isNewPackageFormDisable={false}
            onFinish={onFinish}
            responseData={responseData}
            deviceType={deviceType}
            carrierCompany={carrierCompany}
            isDisplayPackageId={false}
            submitButtonName="Δημιουργία"
            isDisabledOBDType={false} 
            isNewOnChangeValue={isNewOnChangeValue}
            handleIsNewChanged={handleIsNewChanged}  
            isVisibleUpdateButton="true"
             deviceTypeId={ deviceTypeId}
        />
    );
}